export const REASON_DONE = 1;
export const REASON_NOT_DONE_FROM_CONTRACTOR = 2;
export const REASON_NOT_DONE_FROM_PARTNER = 3;
